import {h, Fragment} from "preact"
import { useAppStateSelector, useSelectedFiltersCount, pick } from "@nosto/preact";
import { useGrid } from "./GridContext";
import Icon from "./elements/Icon";
import { toggleButtonId } from "./Sidebar";

function ToggleMobileSidebarButton({ selectedFiltersCount, className }) {
    const { loading, query, response, pageType } = useAppStateSelector(state =>
        pick(state, "response")
    );
    return (
        <label
            htmlFor={toggleButtonId}
            className="mobile-filter-btn flex"
        >
             <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.41465 7C8.20873 7.5826 7.65311 8 7 8C6.34689 8 5.79127 7.5826 5.58535 7C5.53008 6.84361 5.5 6.67532 5.5 6.5C5.5 6.32468 5.53008 6.15639 5.58535 6C5.79127 5.4174 6.34689 5 7 5C7.65311 5 8.20873 5.4174 8.41465 6C8.46992 6.15639 8.5 6.32468 8.5 6.5C8.5 6.67532 8.46992 6.84361 8.41465 7ZM9.44999 6C9.21836 4.85888 8.20948 4 7 4C5.79052 4 4.78164 4.85888 4.55001 6H3V7H4.55001C4.78164 8.14112 5.79052 9 7 9C8.20948 9 9.21836 8.14112 9.44999 7H17V6H9.44999ZM11.5854 14C11.7913 14.5826 12.3469 15 13 15C13.6531 15 14.2087 14.5826 14.4146 14C14.4699 13.8436 14.5 13.6753 14.5 13.5C14.5 13.3247 14.4699 13.1564 14.4146 13C14.2087 12.4174 13.6531 12 13 12C12.3469 12 11.7913 12.4174 11.5854 13C11.5301 13.3247 11.5 13.3247 11.5 13.5C11.5 13.6753 11.5301 13.8436 11.5854 14ZM10.55 13C10.7816 11.8589 11.7905 11 13 11C14.2095 11 15.2184 11.8589 15.45 13H17V14H15.45C15.2184 15.1411 14.2095 16 13 16C11.7905 16 10.7816 15.1411 10.55 14H3V13H10.55Z" fill="#F4F4F4"/>
            </svg>
            <span>Filter</span>
            <span>({response.products?.total})</span>
        </label>
    );
}

export default function Toolbar() {
    const { loading, query, response, pageType } = useAppStateSelector(state =>
        pick(state, "loading", "query", "response", "pageType")
    );
    const selectedFiltersCount = useSelectedFiltersCount();
    const { gridOption, setGridOption, showOnModel, setShowOnModel } = useGrid();

    const handleGridChange = event => {
        setGridOption(event.target.value);
    };

    const handleViewChange = event => {
        setShowOnModel(event.target.value === "model");
    };

    // Detect mobile view (assuming mobile is <= 767px, adjust as needed)
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 767;

    // Map grid options to display values for mobile
    const gridDisplayValues = isMobile
        ? { "2": "1", "4": "2", "6": "6" }
        : { "2": "2", "4": "4", "6": "6" };

    return (
        <div
            className="ns-header-controls ns-d-flex items-center ns-d-none ns-d-md-flex ns-flex-wrap align-center ns-md-justify-content-end"
            style={loading ? { opacity: 0.3, justifyContent: "end" } : {}}
        >
            <ToggleMobileSidebarButton selectedFiltersCount={selectedFiltersCount} />

            <div className="ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-md-block nos-w-100">
                <div className="ns-radio-group view-group">
                    {["2", "4", "6"].map((option, index) => (
                        <div className={`grid-option-wrap grid-option-wrap-${index}`} key={option}>
                            <input
                                type="radio"
                                value={option}
                                checked={gridOption === option}
                                onChange={handleGridChange}
                                id={option}
                                className="ns-radio-input"
                            />
                            {index !== 0 ? '|' : ''}
                            <label htmlFor={option} className={`grid-template-option-${option}`}>
                                <span>{gridDisplayValues[option]}</span>
                            </label>
                        </div>
                    ))}
                </div>
            </div>
            <div className="ns-radio-group view-group model-group">
                {["product", "model"].map((view, index) => (
                    <>
                        <input
                            type="radio"
                            value={view}
                            checked={showOnModel === (view === "model")}
                            onChange={handleViewChange}
                            id={view}
                            className="ns-radio-input"
                            name="view-type"
                        />
                        <label htmlFor={view} key={view} className={`view-type-option-${view}`}>
                            <span>{view.charAt(0).toUpperCase() + view.slice(1)}</span>
                        </label>
                        {index !== 1 ? '|' : ''}
                    </>
                ))}
            </div>
        </div>
    );
}